/**
 * A codes domain — a domain staff bought for EyeMed codes and added on the
 * staff console's Portal Codes list (`codesDomains/{domain}`). Shared so the
 * console's add form and the callable refuse the same values.
 */

/** One DNS label: letters, digits and hyphens, not at either end. */
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * A lowercase DNS name of two or more labels, whose last label (the
 * top-level domain) starts with a letter, so an IP address is not a domain.
 * Callers lowercase and trim what staff typed before asking.
 */
export function isCodesDomainName(value: unknown): value is string {
  if (typeof value !== "string" || value.length === 0 || value.length > 253) return false;
  const labels = value.split(".");
  if (labels.length < 2 || !labels.every((label) => LABEL.test(label))) return false;
  return /^[a-z]/.test(labels[labels.length - 1]);
}

/**
 * A mailbox name an admin typed for a new Versant address (the part before
 * the @): 1–64 of `a-z 0-9 . _ -`, no dot at either end, no doubled dot.
 * A name outside this is refused, never rewritten, since the admin is about
 * to type it into Versant. Callers lowercase and trim before asking.
 */
export function isMailboxName(value: unknown): value is string {
  if (typeof value !== "string" || !/^[a-z0-9._-]{1,64}$/.test(value)) return false;
  return !value.startsWith(".") && !value.endsWith(".") && !value.includes("..");
}
